import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monSetMyTimezone',
    standalone: true,
})
export class SetToMyTimezonePipe implements PipeTransform {
    transform (time: string | Date): Date {
        // Convert input to Date if it's not already
        const dateTime = time instanceof Date ? time : new Date(time);

        // Local timezone offset in hours (positive means behind UTC, negative means ahead of UTC)
        const myTimezoneOffset = new Date().getTimezoneOffset() / 60;

        // Get time in milliseconds
        const timeInMilliSeconds = dateTime.getTime();

        // Server's timezone offset in hours
        const timezoneOffset = dateTime.getTimezoneOffset() / 60;

        // Calculate difference in milliseconds
        const differenceInMilliseconds = (myTimezoneOffset - timezoneOffset) * (1000 * 60 * 60);

        // Return adjusted date
        return new Date(timeInMilliSeconds - differenceInMilliseconds);
    }
}
